import NewBlog from "../Components/NewBlog"
export default function New() {
  return (
    <div>
      <NewBlog />
    </div>
  )
}
